var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectCarret(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.09221 8.36434C5.7615 8.05405 5.24318 8.07201 4.93451 8.40448C4.62585 8.73694 4.64372 9.258 4.97443 9.5683L11.441 15.6357C11.7557 15.931 12.2441 15.931 12.5588 15.6357L19.0254 9.5683C19.3561 9.258 19.374 8.73694 19.0653 8.40448C18.7567 8.07201 18.2384 8.05405 17.9076 8.36434L11.9999 13.9074L6.09221 8.36434Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectCarret);
export default __webpack_public_path__ + "static/media/select-carret.e04afbc0693b16ee22ecbaa15583f211.svg";
export { ForwardRef as ReactComponent };